import {AfterViewInit, Component, inject, input, signal} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {CarouselModule, OwlOptions} from "ngx-owl-carousel-o";
import {QRCodeComponent} from "angularx-qrcode";
import {NgOptimizedImage} from "@angular/common";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/all";
import {AccountService} from "../../../services/account/account.service";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";


@Component({
  selector: 'app-home-start-trading',
  imports: [
    TranslateModule,
    CarouselModule,
    QRCodeComponent,
    NgOptimizedImage,
    SafeHtmlPipe,
  ],
  templateUrl: './home-start-trading.component.html',
  styles: ``
})
export class HomeStartTradingComponent implements AfterViewInit {
  account = inject(AccountService);
  qrData = input.required<string>();
  customOptions = signal<OwlOptions>({
    loop: false,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 1000,
    autoplay: false,
    nav: true,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      560: {
        items: 2
      },
      1100: {
        items: 3
      }
    },
  });

  ngAfterViewInit(): void {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.defaults({
      start: 'top 80%'
    })
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.home-start-section',
      }
    });

    tl.addLabel('start')
      .from('#home-steps-title', {
        opacity: 0,
        y: 50,
        duration: 0.3,
      })
      .from('.steps-carousel', {
        opacity: 0,
        duration: 0.5,
      })
  }

  async showAction(): Promise<void> {
    await this.account.showAction();
  }

}
